import BaseUrl from '../../types/BaseUrl';
import ICampaignInfoContainer from "../../types/ICampaignInfoContainer";
import Options from '../../types/Options';
import CampaignInfoCookieContainer from "./cookie";
import CampaignInfoInjectionContainer from "./injection";
import CampaignInfoStorageContainer from "./localStorage";
import CampaignInfoParamContainer from "./param";

// Class that loads all containers by priority in an array. will iterate and decide.
export default class CampaignInfoAllContainers extends Array<ICampaignInfoContainer> {
  constructor(baseUrl: BaseUrl, options: Options) {
    super();

    this.push(new CampaignInfoParamContainer());
    this.push(new CampaignInfoCookieContainer(baseUrl));
    this.push(new CampaignInfoStorageContainer());
    this.push(new CampaignInfoInjectionContainer(options))
  }
}